"use strict";
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ibh = void 0;
const http_client_1 = require("./http-client");
class Ibh extends http_client_1.HttpClient {
    constructor() {
        super(...arguments);
        /**
         * @description List of available bearing shapes with associated widen info.
         *
         * @tags IBH
         * @name Shapes
         * @request GET:/ibh/shapes
         * @secure
         * @response `200` `(IbhShapeResponseDto)[]`
         */
        this.shapes = (params = {}) => this.request({
            path: `/ibh/shapes`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Returns the details of a catalog article for given article number
         *
         * @tags IBH Article
         * @name CatalogArticle
         * @request GET:/ibh/article/catalog/{articleNumber}
         * @secure
         * @response `200` `IbhCatalogArticleResponseDto`
         */
        this.catalogArticle = ({ articleNumber, ...query }, params = {}) => this.request({
            path: `/ibh/article/catalog/${encodeURIComponent(articleNumber)}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Returns the details of a custom article for given article number and query params
         *
         * @tags IBH Article
         * @name CustomArticle
         * @request GET:/ibh/article/custom/{articleNumber}
         * @secure
         * @response `200` `IbhCustomArticleResponseDto`
         */
        this.customArticle = ({ articleNumber, ...query }, params = {}) => this.request({
            path: `/ibh/article/custom/${encodeURIComponent(articleNumber)}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Returns the details of a custom ICN article for given article number and query params
         *
         * @tags IBH Article
         * @name IcnArticle
         * @request GET:/ibh/article/icn/{articleNumber}
         * @secure
         * @response `200` `IbhIcnArticleResponseDto`
         */
        this.icnArticle = ({ articleNumber, ...query }, params = {}) => this.request({
            path: `/ibh/article/icn/${encodeURIComponent(articleNumber)}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Returns the lifetime of a catalog part
         *
         * @tags IBH Article
         * @name CatalogArticleLifetime
         * @request GET:/ibh/article/lifetime/catalog/{articleNumber}
         * @secure
         * @response `200` `IbhArticleLifetimeResponseDto`
         */
        this.catalogArticleLifetime = ({ articleNumber, ...query }, params = {}) => this.request({
            path: `/ibh/article/lifetime/catalog/${encodeURIComponent(articleNumber)}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Returns the lifetime of a custom part
         *
         * @tags IBH Article
         * @name CustomArticleLifetime
         * @request GET:/ibh/article/lifetime/custom/{articleNumber}
         * @secure
         * @response `200` `IbhArticleLifetimeResponseDto`
         */
        this.customArticleLifetime = ({ articleNumber, ...query }, params = {}) => this.request({
            path: `/ibh/article/lifetime/custom/${encodeURIComponent(articleNumber)}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Returns a list of matching catalog article numbers
         *
         * @tags IBH Article
         * @name CatalogArticleNumbers
         * @request GET:/ibh/article-numbers
         * @secure
         * @response `200` `IbhCatalogArticleNumbersResponseDto`
         */
        this.catalogArticleNumbers = (query, params = {}) => this.request({
            path: `/ibh/article-numbers`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Returns a matrix of matching catalog article numbers
         *
         * @tags IBH Article
         * @name CatalogArticleMatrix
         * @request GET:/ibh/article-matrix
         * @secure
         * @response `200` `IbhCatalogArticleMatrixResponseDto`
         */
        this.catalogArticleMatrix = (query, params = {}) => this.request({
            path: `/ibh/article-matrix`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Returns catalog parts price scales
         *
         * @tags IBH Article
         * @name CatalogArticlePriceScales
         * @request GET:/ibh/article/scale/catalog/{articleNumber}
         * @secure
         * @response `200` `(IbhArticlePriceScalesResponseDto)[]`
         */
        this.catalogArticlePriceScales = ({ articleNumber, ...query }, params = {}) => this.request({
            path: `/ibh/article/scale/catalog/${encodeURIComponent(articleNumber)}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Returns custom parts price scales
         *
         * @tags IBH Article
         * @name CustomArticlePriceScales
         * @request GET:/ibh/article/scale/custom/{articleNumber}
         * @secure
         * @response `200` `(IbhArticlePriceScalesResponseDto)[]`
         */
        this.customArticlePriceScales = ({ articleNumber, ...query }, params = {}) => this.request({
            path: `/ibh/article/scale/custom/${encodeURIComponent(articleNumber)}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Adds an article to the basket
         *
         * @tags IBH Basket
         * @name AddToBasket
         * @request POST:/ibh/basket
         * @secure
         * @response `201` `IbhBasketResponseDto`
         */
        this.addToBasket = (query, data, params = {}) => this.request({
            path: `/ibh/basket`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: http_client_1.ContentType.Json,
            format: "json",
            ...params,
        });
        /**
         * @description Update an article in the basket
         *
         * @tags IBH Basket
         * @name UpdateBasket
         * @request PUT:/ibh/basket
         * @secure
         * @response `200` `IbhBasketResponseDto`
         */
        this.updateBasket = (query, data, params = {}) => this.request({
            path: `/ibh/basket`,
            method: "PUT",
            query: query,
            body: data,
            secure: true,
            type: http_client_1.ContentType.Json,
            format: "json",
            ...params,
        });
        /**
         * @description Adds an ICN article to the basket
         *
         * @tags IBH Basket
         * @name AddToBasketIcn
         * @request POST:/ibh/basket/icn
         * @secure
         * @response `201` `IbhBasketResponseDto`
         */
        this.addToBasketIcn = (query, data, params = {}) => this.request({
            path: `/ibh/basket/icn`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: http_client_1.ContentType.Json,
            format: "json",
            ...params,
        });
        /**
         * @description Update an ICN article in the basket
         *
         * @tags IBH Basket
         * @name UpdateBasketIcn
         * @request PUT:/ibh/basket/icn
         * @secure
         * @response `200` `IbhBasketResponseDto`
         */
        this.updateBasketIcn = (query, data, params = {}) => this.request({
            path: `/ibh/basket/icn`,
            method: "PUT",
            query: query,
            body: data,
            secure: true,
            type: http_client_1.ContentType.Json,
            format: "json",
            ...params,
        });
        /**
         * @description Read out cart configuration position
         *
         * @tags IBH Basket
         * @name GetCartPositionById
         * @request POST:/ibh/basket/position
         * @secure
         * @response `201` `IbhCartPositionResponseDto`
         */
        this.getCartPositionById = (query, data, params = {}) => this.request({
            path: `/ibh/basket/position`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: http_client_1.ContentType.Json,
            format: "json",
            ...params,
        });
        /**
         * @description Returns the url to download file of a catalog article for given articleNumber
         *
         * @tags IBH Files
         * @name CatalogArticleFileLink
         * @request GET:/ibh/files/catalog/link/{fileType}/{articleNumber}
         * @secure
         * @response `200` `IbhFileResponseDto`
         */
        this.catalogArticleFileLink = ({ fileType, articleNumber, ...query }, params = {}) => this.request({
            path: `/ibh/files/catalog/link/${encodeURIComponent(fileType)}/${encodeURIComponent(articleNumber)}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Returns the url to download file of a custom article for given articleNumber and dimensions
         *
         * @tags IBH Files
         * @name CustomArticleFileLink
         * @request GET:/ibh/files/custom/link/{fileType}/{articleNumber}
         * @secure
         * @response `200` `IbhFileResponseDto`
         */
        this.customArticleFileLink = ({ fileType, articleNumber, ...query }, params = {}) => this.request({
            path: `/ibh/files/custom/link/${encodeURIComponent(fileType)}/${encodeURIComponent(articleNumber)}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Returns the model file of a catalog article for given articleNumber
         *
         * @tags IBH Files
         * @name CatalogArticleFileModel
         * @request GET:/ibh/files/catalog/raw/{fileType}/{articleNumber}
         * @secure
         * @response `200` `void`
         */
        this.catalogArticleFileModel = ({ fileType, articleNumber, ...query }, params = {}) => this.request({
            path: `/ibh/files/catalog/raw/${encodeURIComponent(fileType)}/${encodeURIComponent(articleNumber)}`,
            method: "GET",
            secure: true,
            ...params,
        });
        /**
         * @description Returns the model file of a custom article for given articleNumber and dimensions
         *
         * @tags IBH Files
         * @name CustomArticleFileModel
         * @request GET:/ibh/files/custom/raw/{fileType}/{articleNumber}
         * @secure
         * @response `200` `void`
         */
        this.customArticleFileModel = ({ fileType, articleNumber, ...query }, params = {}) => this.request({
            path: `/ibh/files/custom/raw/${encodeURIComponent(fileType)}/${encodeURIComponent(articleNumber)}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
        /**
         * @description Returns zip files of a catalog article for a given articleNumber
         *
         * @tags IBH Files
         * @name CatalogArticleAllFiles
         * @request GET:/ibh/files/catalog/zip/all/{articleNumber}
         * @secure
         * @response `200` `void`
         * @response `206` `void` partial response
         */
        this.catalogArticleAllFiles = ({ articleNumber, ...query }, params = {}) => this.request({
            path: `/ibh/files/catalog/zip/all/${encodeURIComponent(articleNumber)}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
        /**
         * @description Returns zip files of a custom article for a given articleNumber and dimensions
         *
         * @tags IBH Files
         * @name CustomArticleAllFiles
         * @request GET:/ibh/files/custom/zip/all/{articleNumber}
         * @secure
         * @response `200` `void`
         * @response `206` `void` partial response
         */
        this.customArticleAllFiles = ({ articleNumber, ...query }, params = {}) => this.request({
            path: `/ibh/files/custom/zip/all/${encodeURIComponent(articleNumber)}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
        /**
         * @description Get default lifetime form config, Prefer usage of `defaultLifetimeFormConfig` from "@igus/tribology-domain"
         *
         * @tags IBH Lifetime Form Config
         * @name LifetimeFormConfig
         * @request GET:/ibh/lifetime/form-config
         * @deprecated
         * @secure
         * @response `200` `IbhLifetimeFormConfigResponseDto`
         */
        this.lifetimeFormConfig = (params = {}) => this.request({
            path: `/ibh/lifetime/form-config`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description List of material data based on the given production method and shape
         *
         * @tags IBH Materials
         * @name BearingMaterials
         * @request GET:/ibh/materials
         * @secure
         * @response `200` `(IbhMaterialResponseDto)[]`
         */
        this.bearingMaterials = (query, params = {}) => this.request({
            path: `/ibh/materials`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Material description for material data based on the given material code and locale
         *
         * @tags IBH Materials
         * @name BearingMaterialsDescription
         * @request GET:/ibh/materials/description
         * @secure
         * @response `200` `IbhMaterialDescriptionResponseDto`
         */
        this.bearingMaterialsDescription = (query, params = {}) => this.request({
            path: `/ibh/materials/description`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
        /**
         * @description Returns a list of matching parts
         *
         * @tags IBH Parts
         * @name BearingPartsLight
         * @request POST:/ibh/parts
         * @secure
         * @response `201` `(IbhPartsResponseDto)[]`
         */
        this.bearingPartsLight = (query, data, params = {}) => this.request({
            path: `/ibh/parts`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: http_client_1.ContentType.Json,
            format: "json",
            ...params,
        });
        /**
         * @description Returns a list of matching ICN parts
         *
         * @tags IBH Parts
         * @name BearingPartsIcn
         * @request POST:/ibh/parts/icn
         * @secure
         * @response `201` `(IbhIcnPartsResponseDto)[]`
         */
        this.bearingPartsIcn = (query, data, params = {}) => this.request({
            path: `/ibh/parts/icn`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: http_client_1.ContentType.Json,
            format: "json",
            ...params,
        });
        /**
         * @description Returns a list of similar parts with minimal data from the catalog only
         *
         * @tags IBH Parts
         * @name SimilarPartsLight
         * @request POST:/ibh/similar-parts
         * @secure
         * @response `201` `(IbhPartsResponseDto)[]`
         */
        this.similarPartsLight = (query, data, params = {}) => this.request({
            path: `/ibh/similar-parts`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: http_client_1.ContentType.Json,
            format: "json",
            ...params,
        });
        /**
         * @description Returns the lifetime of matching parts
         *
         * @tags IBH Parts
         * @name BearingPartsLifetime
         * @request POST:/ibh/parts/lifetime
         * @secure
         * @response `201` `IbhPartsLifetimeResponseDto`
         */
        this.bearingPartsLifetime = (query, data, params = {}) => this.request({
            path: `/ibh/parts/lifetime`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: http_client_1.ContentType.Json,
            format: "json",
            ...params,
        });
        /**
         * @description List of available production methods based on given shape filtered by sessions priceCountry
         *
         * @tags IBH Materials
         * @name ProductionMethodsByLocale
         * @request GET:/ibh/production-methods
         * @secure
         * @response `200` `(IbhProductionMethodResponseDto)[]`
         */
        this.productionMethodsByLocale = (query, params = {}) => this.request({
            path: `/ibh/production-methods`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        });
    }
}
exports.Ibh = Ibh;
//# sourceMappingURL=Ibh.js.map